<template>
    <section :aria-label="$t('grow-font-btn')">
        <p class="text-center mb-0">
            <router-link :to="{ name: '' }" @click.native="growFont()" :aria-label="$t('increase-font-size')">
                <img src="@/assets/images/AA-purple@2x.png" :height="imgHeight" :alt="$t('increase-font-size')">
            </router-link>
        </p>
    </section>
</template>
<script>
import { EventBus } from '@/helpers/EventBus.js';

export default {
    props:   ['fontSize'],
    data () {
        return {
            imgHeight:   20,
            timer:       20,
            windowWidth: window.innerWidth,
        }
    },
    mounted () {
        this.resizeImage();

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        /**
         * Increase font size Event
         */
        growFont () {
            switch (true) {
                case this.fontSize['normal-font'] === true:
                    this.$session.set('growFont', 'big-font');
                    EventBus.$emit('grow-font', 'big-font');
                    break;
                case this.fontSize['big-font'] === true:
                    this.$session.set('growFont', 'giant-font');
                    EventBus.$emit('grow-font', 'giant-font');
                    break;
                case this.fontSize['giant-font'] === true:
                    this.$session.set('growFont', 'normal-font');
                    EventBus.$emit('grow-font', 'normal-font');
                    break;
                default:
                    this.$session.set('growFont', 'normal-font');
                    EventBus.$emit('grow-font', 'normal-font');
            }

            this.resizeImage();
        },

        /**
         * On resize the width of the window update the windowWidth and resize the image,
         */
        onResize() {
            this.windowWidth = window.innerWidth;
            this.resizeImage();
        },

        /**
         * Resize the font image to be like the font-size.
         */
        resizeImage () {
            // Wait this timer to get font-size.
            setTimeout(() => {
                this.imgHeight = 20;

                if (this.fontSize['big-font']) {
                    this.imgHeight += 3;
                } else if (this.fontSize['giant-font']) {
                    this.imgHeight += 6;
                }
            }, this.timer);

        }
    }
};
</script>
